<div class="template-panel">
  <p class="template-intro">
    Contact your project and set a date for the final meeting. Contact the project at the e-mail address you find on the Assigned Services page, or by accessing that association's service.
  </p>
  <p class="template-intro">
    Send the contact an e-mail using <strong>the suggested template</strong> below:
  </p>

  <button type="button" class="template-toggle" (click)="opened = !opened">
    Final meeting contact e-mail template
    <i class="fa" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>

  <div *ngIf="opened" class="template-body">
    <p><strong>Subject: HSBooster.eu – Final meeting with Expert</strong></p>
    <p>Dear [Project Applicant Name],</p>
    <p>I am contacting you regarding the standardisation consultancy service delivered to your project [project name].</p>
    <p>I would like to schedule a call with you to discuss the main outcomes of this service. Here are some options that you can choose from:</p>
    <ul>
      <li>Insert option 1</li>
      <li>Insert option 2</li>
      <li>Insert option 3</li>
    </ul>
    <p>This will be a final meeting which will help us extract key lessons learned, evaluate the progress and outline possible steps for a future standardisation strategy.</p>
    <p>Looking forward to your feedback.</p>
    <p>Best regards,<br>Expert signature</p>
  </div>
</div>
